import random from 'lodash/random'

import { updateUrlWithFilterParams } from '../../../util/filter/setUrlFilterParams'
import { flyGaLogic } from '../../../util/flyGaLogic'
import { filterMessageOptions } from './constants'
// eslint-disable-next-line no-unused-vars

/**
 * Loads appropriate loading screen message
 */
export const getLoadingScreenMessage = (isSliceSelection, displayType) => {
  if (isSliceSelection) {
    return 'Combining new flight options...'
  }

  if (displayType === 'sort') {
    return 'Sorting flights...'
  }

  const randomOption = random(2)
  return filterMessageOptions[randomOption]
}

/**
 * The following check makes sure that updateUrlWithFilterParams is not called for
 * TIME and Duration Filters saving function calls
 */
export const updateFilterURL = (
  isSliceSelection,
  displayType,
  latestFilterChange,
  isSBS,
  defaults
) => {
  if (!isSliceSelection && displayType !== 'sort') {
    const { numOfStops, includedCarriers, origAirports1 } = latestFilterChange
    const callUpdateUrlWithFilterParams =
      numOfStops || includedCarriers || origAirports1

    // Update URL on changing the filters.
    if (!isSBS && callUpdateUrlWithFilterParams) {
      updateUrlWithFilterParams(latestFilterChange, defaults)
    }

    flyGaLogic.fire.filterTags(latestFilterChange, defaults)
  }
}
